var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3325 13.5832C5.00724 13.5832 6.36488 12.2367 6.36488 10.5756C6.36488 8.91455 5.00724 7.56799 3.3325 7.56799C1.65776 7.56799 0.30011 8.91455 0.30011 10.5756C0.30011 12.2367 1.65776 13.5832 3.3325 13.5832Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33231 14.2704C1.40936 14.2704 0 15.9499 0 17.6863V18.8545C0 19.0197 0.135363 19.1558 0.302575 19.1558H0.410069H6.25322H6.36071C6.52793 19.1558 6.66461 19.0197 6.66461 18.8545V17.6863C6.66461 15.9499 5.25525 14.2704 3.33231 14.2704Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2153 12.9638C13.0762 12.9638 14.5848 11.4675 14.5848 9.62184C14.5848 7.77614 13.0762 6.27991 11.2153 6.27991C9.35439 6.27991 7.84583 7.77614 7.84583 9.62184C7.84583 11.4675 9.35439 12.9638 11.2153 12.9638Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2156 13.7262C9.07902 13.7262 7.51306 15.5934 7.51306 17.5227V18.8217C7.51306 19.0054 7.66435 19.156 7.85014 19.156H7.96958H14.4617H14.5811C14.7669 19.156 14.9182 19.0054 14.9182 18.8217V17.5227C14.9169 15.5934 13.3509 13.7262 11.2156 13.7262Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8856 12.2765C21.9525 12.2765 23.628 10.614 23.628 8.56324C23.628 6.51246 21.9525 4.84998 19.8856 4.84998C17.8188 4.84998 16.1432 6.51246 16.1432 8.56324C16.1432 10.614 17.8188 12.2765 19.8856 12.2765Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8861 13.1234C17.512 13.1234 15.7722 15.1981 15.7722 17.3415V18.7845C15.7722 18.988 15.9394 19.1558 16.1464 19.1558H16.2791H23.4931H23.6258C23.8329 19.1558 24.0001 18.988 24.0001 18.7845V17.3415C24.0001 15.1981 22.2589 13.1234 19.8861 13.1234Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyspace);
export default __webpack_public_path__ + "static/media/myspace.b26e4901.svg";
export { ForwardRef as ReactComponent };